import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AlertController, LoadingController, Platform, PopoverController, ToastController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthMember } from '@shared/models';
import { TranslateService } from '@ngx-translate/core';
import { SwUpdate } from '@angular/service-worker';
import { AuthenticationService } from '@shared/services';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { interval } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { KeyValue } from '@angular/common';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment';

import { environment } from '@env';

import { HeaderDropdownComponent } from '@shared/components/header-dropdown/header-dropdown.component';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

    public version = '1.5.9';

    public selectedIndex = 0;
    public appPages = {
        membershipcard: {
            title: 'Membership Card',
            url: '/membership-card',
            icon: 'card',
            order: 2,
        },
    };
    public title = 'Home';
    public baseUrl = environment.baseUrl;

    public updateMessageAsToast = false;
    private templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

    constructor(
        private translate: TranslateService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private loadingController: LoadingController,
        private alertController: AlertController,
        private toastController: ToastController,
        private popoverController: PopoverController,
        private authenticationService: AuthenticationService,
        private swUpdate: SwUpdate,
        private titleService: Title,
        private http: HttpClient,
    ) {
        this.initializeApp();
    }

    menuOrder = (a: KeyValue<number, any>, b: KeyValue<number, any>): number => {
        return a.value.order < b.value.order ? -1 : (b.value.order < a.value.order ? 1 : 0);
    }
    
    initializeApp() {
        moment.locale('nl');
        this.translate.setDefaultLang('nl');
        this.translate.use('nl');
        
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
        
        if (this.swUpdate.isEnabled) {
            this.swUpdate.available.subscribe(() => {
                this.showUpdateMessage();
            });

            // Check for updates every 10 minutes
            interval(1000 * 60 * 10).subscribe(() => {
                this.updateMessageAsToast = false;

                this.swUpdate.checkForUpdate().then(() => {
                    console.log('Checking for updates');
                });
            });

            this.swUpdate.checkForUpdate().then(() => {
                console.log('Checking for updates on init');
            });
        }

        this.translate.get('membership-card.title').subscribe(x => this.appPages.membershipcard.title = x);

        /* this.translate.get('user.reserve.title').subscribe(x => this.appPages.reserve.title = x);
        // this.translate.get('user.checkin.title').subscribe(x => this.appPages.checkin.title = x);
        this.translate.get('user.membership-card.title').subscribe(x => this.appPages.membershipcard.title = x);
        this.translate.get('user.dashboard.title').subscribe(x => this.appPages.dashboard.title = x);
        this.translate.get('user.profile.title').subscribe(x => this.appPages.profile.title = x);
        
        this.translate.get('company.dashboard.title').subscribe(x => this.appPages.company_dashboard.title = x);
        this.translate.get('company.settings.title').subscribe(x => this.appPages.company_settings.title = x); */
    }

    ngOnInit() {
        const appTitle = this.titleService.getTitle();
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => {
                let child = this.activatedRoute.firstChild;
                while (child.firstChild) {
                    child = child.firstChild;
                }

                if (child.snapshot.data['title']) {
                    const params = child.snapshot.params;
                    return child.snapshot.data['title'].replace(this.templateMatcher, (substring: string, b: string) => {
                        return params[b] ?? substring;
                    });
                }

                return appTitle;
            })
        ).subscribe((title: string) => {
            this.title = title;
            this.titleService.setTitle(appTitle);
            this.translate.stream(title).subscribe(x => this.titleService.setTitle(x));
        });
    }

    switchLanguage() {
        let lang = 'nl';
        if (this.translate.currentLang != 'nl') {
            lang = 'nl';
        } else {
            lang = 'en';
        }

        this.translate.use(lang);
        this.translate.reloadLang(lang);
    }

    async showUpdateMessage() {
        if (this.updateMessageAsToast) {

            const toast = await this.toastController.create({
                header: this.translate.instant('messages.new_update.title'),
                message: this.translate.instant('messages.new_update.message'),
                position: 'top',
                color: 'success',
                cssClass: 'update-toast',
                buttons: [
                    {
                        text: this.translate.instant('messages.new_update.yes'),
                        cssClass: 'button-success',
                        icon: 'checkmark-outline',
                        handler: () => {

                            this.swUpdate.activateUpdate().then(() => {
                                window.location.reload();
                            });

                        }
                    },
                    {
                        text: this.translate.instant('messages.new_update.cancel'),
                        role: 'cancel',
                        cssClass: 'button-danger'
                    }
                ]
            });

            await toast.present();

        } else {

            const alert = await this.alertController.create({
                // cssClass: 'my-custom-class',
                header: this.translate.instant('messages.new_update.title'),
                message: this.translate.instant('messages.new_update.message'),
                backdropDismiss: false,
                buttons: [
                    {
                        text: this.translate.instant('messages.new_update.yes'),
                        cssClass: 'text-success mr-4',
                        handler: () => {

                            this.swUpdate.activateUpdate().then(() => {
                                window.location.reload();
                            });

                        }
                    }/* ,
                    {
                        text: this.translate.instant('messages.new_update.cancel'),
                        role: 'cancel',
                        cssClass: 'text-danger'
                    } */
                ]
            });

            await alert.present();

        }
    }

    async openHeaderMenu(event: any) {
        const popover = await this.popoverController.create({
            component: HeaderDropdownComponent,
            event: event,
        });
        await popover.present();
        const { data } = await popover.onDidDismiss();
        
        switch (data) {
            case 'logout':
                this.logout();
                break;
        }
        
    }

    async logout() {
        const loading = await this.loadingController.create({
            message: 'Laden...',
        });
        await loading.present();

        await this.authenticationService.logout();

        loading.dismiss();
    }
}
